/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Trigger/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaInputDateRangeArrow from './TysiaInputDateRangeArrow/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Trigger({
  children,
  viewPath = "/DesignSystem/TysiaInputDateRange/Trigger",
  marginTop,
  marginLeft,
  marginRight,
  marginBottom,
  required,
  size,
  label,
  borderBottomLeftRadius = 4,
  borderBottomRightRadius = 4,
  borderTopLeftRadius = 4,
  borderTopRightRadius = 4,
  borderWidth = 1,
  borderColor,
  paddingLeft,
  paddingRight,
  maxWidth,
  width = "100%",
  text
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let marginTopOrdtSpaceM = marginTop ?? dtSpaceM
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let paddingLeftOrdtSpaceLs = paddingLeft ?? dtSpaceLs
let paddingRightOrdtSpaceLs = paddingRight ?? dtSpaceLs
let borderColorOrdtColorsNeutral300 = borderColor ?? dtColorsNeutral300
  return (<React.Fragment
>
<div
  data-testid="Trigger.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-HFmAS': typeof marginTopOrdtSpaceM === 'number' ? `${marginTopOrdtSpaceM}px` : marginTopOrdtSpaceM,'--ml-2-HFmAS': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-3-HFmAS': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mb-4-HFmAS': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaInputLabel
  viewPath={`${viewPath}/TysiaInputLabel`}
 required={required}
 size={size}
 text={label}
/>
<div
  data-testid="Trigger.Horizontal"
  data-view-path={viewPath}
 style={{'--bblr-5-HFmAS': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-6-HFmAS': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-7-HFmAS': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-8-HFmAS': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--bw-9-HFmAS': typeof borderWidth === 'number' ? `${borderWidth}px` : borderWidth,'--bc-10-HFmAS': borderColorOrdtColorsNeutral300,'--mw-14-HFmAS': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--w-15-HFmAS': typeof width === 'number' ? `${width}px` : width,'--h-11-HFmAS': size === "small" ? "24px" : "30px",'--pl-12-HFmAS': size === "small" ? typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs : typeof paddingLeftOrdtSpaceLs === 'number' ? `${paddingLeftOrdtSpaceLs}px` : paddingLeftOrdtSpaceLs,'--pr-13-HFmAS': size === "small" ? typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs : typeof paddingRightOrdtSpaceLs === 'number' ? `${paddingRightOrdtSpaceLs}px` : paddingRightOrdtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size={size}
 text={text}
/>
<TysiaInputDateRangeArrow
  viewPath={`${viewPath}/TysiaInputDateRangeArrow`}
/>
</div>
</div>
{children}
</React.Fragment>)
}